<template>
      <div class="advancedReportsContainer">
        <div class="headerWrapper"> 
            <div class="titleWrapper"> 
                <img @click="onBackBtnClick" class="arrow" src="../assets/backArrow.svg">
                <div class="title"> Saved Reports </div>
            </div>
            <!-- <div class="saveBtn" @click="onSaveAndScheduleReport"> Save and schedule reports</div> -->
        </div> 

        
        <div class="rows"> 
            <table style="width: 100%">
                <thead>
                    <tr class="headerRow">
                        <th class="rowtitle">Date of creation</th>
                        <th class="rowtitle">Report name</th>
                        <th class="rowtitle">Report type</th>
                        <th class="rowtitle">Created by</th>
                        <th class="rowtitle">Start date</th>
                        <th class="rowtitle">End date</th>
                        <th class="rowtitle">Frequency</th>
                        <th class="rowtitle">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="rowItem" v-for="(item, index) in savedReports" :key="index">
                        <td class="item">{{ formatDate(item.reportMetaData.creationDate) }}</td>
                        <td v-if="item.reportMetaData.reportName" class="item name">{{ item.reportMetaData.reportName }}</td>
                        <td v-else style="text-align: center;">-</td>
                        <td v-if="item.reportType" class="item">{{ item.reportType === "KEYWORD_PERFORMANCE_REPORT" ? "targeting value performance report" : item.reportType.replace(/_/g, ' ').toLowerCase()   }}</td>
                        <td v-else style="text-align: center;">-</td>
                        <td class="item">{{item?.reportMetaData?.loggedInEmail ?? '-'}}</td>
                        <td v-if="item.scheduleDetails?.startDate" class="item">{{ formatDate(item?.scheduleDetails.startDate) }}</td>
                        <td v-else class="item">-</td>
                        <td v-if="item.scheduleDetails?.endDate"  class="item">{{ formatDate(item?.scheduleDetails?.endDate) }}</td>
                        <td v-else style="text-align: center;" class="item">-</td>
                        <td v-if="item.scheduleDetails?.frequency"  class="item">{{ item?.scheduleDetails.frequency }}</td>
                        <td v-else style="text-align: center;" class="item">-</td>
                        <td  class="item actions">
                            <img :class="`${item?.reportMetaData?.loggedInRole == 'AGENCY' && role !== 'AGENCY' ? 'hide' : ''} editIcon`" style="cursor: pointer" @click="onEditClick(index, item)" src="../assets/editIcon.svg" alt="edit">
                            <img v-if="item?.reportMetaData?.loggedInRole == 'AGENCY' && role !== 'AGENCY'" class="deleteIcon" style="cursor: pointer" @click="onEditClick(index, item)" src="../assets/eyeIcon.svg" alt="edit">
                            <img v-else class="deleteIcon" style="cursor: pointer" @click="onDeleteReportClick(item.reportEntityId)" src="../assets/deleteIconAnalytics.svg" alt="delete">
                            <img class="downloadIcon" style="cursor: pointer" @click="onDownloadReport(item.reportEntityId)" src="../assets/downloadIconAnalytics.svg" alt="download">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <TwoFaDialog
            v-if="showOTPDialog"
            @cancel="onCancelOTP"
            downloadReport
            :reportEntityId="this.reportEntityId"
        />
      </div>
</template>

<script> 
    import Header from './Header.vue'
    import LeftMenu from './LeftMenu.vue'
    import moment from 'moment';
    import {
        getSavedReports,
        saveAndScheduleReport,
        deleteReport,
        downloadReport,
        generateOtp,
        getCookie
    } from '../services/campaignService';
    import DownloadDialog from './DownloadDialog.vue';
    import TwoFaDialog from './TwoFaDialog.vue'
    import { mapActions } from 'vuex';
    import {API_URL} from '../constants/index';


    export default {
        name: 'SavedReports',
        components: {
            Header,
            LeftMenu,
            DownloadDialog,
            TwoFaDialog
        },
       
        mounted() {
            getSavedReports()
            .then(res => res.json())
            .then(data => {
                this.savedReports = data?.savedReports
            })
            // localStorage.removeItem('reportData')
            this.resetReportData();
            this.resetAdvanceReportBool();
            this.setSavedReportsEditMode(false);
        },
        data() {
            return {
                savedReports: [],
                reportData : [
                    {
                        dateOfCreation: 'Dec 1, 2021',
                        name: 'Sample Name',
                        startDate: 'Dec 5, 2022',
                        endDate: 'Dec 5, 2022',
                        frequency: 'Weekly',
                        emailIds: 'Sampleidname@xyz.com',
                    },
                    {
                        dateOfCreation: 'Dec 1, 2021',
                        name: 'Sample Name',
                        startDate: 'Dec 5, 2022',
                        endDate: 'Dec 5, 2022',
                        frequency: 'Weekly',
                        emailIds: 'Sampleidname@xyz.com',
                    },
                    {
                        dateOfCreation: 'Dec 1, 2021',
                        name: 'Sample Name',
                        startDate: 'Dec 5, 2022',
                        endDate: 'Dec 5, 2022',
                        frequency: 'Weekly',
                        emailIds: 'Sampleidname@xyz.com',
                    },
                    {
                        dateOfCreation: 'Dec 1, 2021',
                        name: 'Sample Name',
                        startDate: 'Dec 5, 2022',
                        endDate: 'Dec 5, 2022',
                        frequency: 'Weekly',
                        emailIds: 'Sampleidname@xyz.com',
                    },
                    {
                        dateOfCreation: 'Dec 1, 2021',
                        name: 'Sample Name',
                        startDate: 'Dec 5, 2022',
                        endDate: 'Dec 5, 2022',
                        frequency: 'Weekly',
                        emailIds: 'Sampleidname@xyz.com',
                    }
                ],
                showOTPDialog: false,
                reportEntityId: null,
                role: getCookie('role')
            }
        },
        methods: {
            ...mapActions(['resetReportData','setReportData','setAdvanceReportBool', 'resetAdvanceReportBool', 'setSavedReportsEditMode']),
            onBackBtnClick(){
                this.$router.push({
                    path: `${this.role === 'SUPERADMIN' || this.role === 'OPS' ? '/admin' : ''}/analytics`,
                })
            },
            onSaveAndScheduleReport(){
                this.$router.push(`${this.role === 'SUPERADMIN' || this.role === 'OPS' ? '/admin' : ''}/save-schedule-report`)
            },
            formatDate(value) {
                if (value) {
                    return moment(String(value)).format('DD-MM-YYYY');
                }
            },
            onEditClick(index, item){
                //localStorage.setItem('reportData', JSON.stringify(item))
                this.setReportData(item);
                this.setSavedReportsEditMode(true);
                if(item.reportType === 'CAMPAIGN_PERFORMANCE_REPORT'){
                    this.$router.push(`${this.role === 'SUPERADMIN' || this.role === 'OPS' ? '/admin' : ''}/save-schedule-report`)
                }else{
                    this.$router.push({ 
                        path: `${this.role === 'SUPERADMIN' || this.role === 'OPS' ? '/admin' : ''}/save-schedule-report`, 
                        query: {advancedReport: true}
                    })
                    this.setAdvanceReportBool(true);
                }
            },
            onDeleteReportClick(reportEntityId){
                deleteReport(reportEntityId)
                .then(res=> res.json())
                .then(data => {
                    if(data.status==='success'){
                        getSavedReports()
                        .then(res => res.json())
                        .then(data => {
                            this.savedReports = data?.savedReports
                        })
                    }
                })
            },
            onDownloadReport(reportEntityId){
                this.showOTPDialog = true;
                this.reportEntityId = reportEntityId
                // downloadReport(reportEntityId)
                // .then(res=>res.json())
                // .then(data=>{
                //     data?.signed_urls.map(url=> {
                //         window.open(url);
                //     })
                // })
            },
            onGenerateOtp(){
                generateOtp()
            },
            onCancelOTP() {
                this.showOTPDialog = false;
            },
        }
    }
</script>

<style scoped>

table{
    table-layout: auto;
    width: 90%;
}
    @font-face {
        font-family: "Inter-Regular";
        src: url('../assets/fonts/Inter-Regular.ttf');
    }

    .name{
        width: 100px;
        text-align: center;
        padding-left: 15px;
    }

    .date{
        margin-left: 40px;
    }

    .deleteIcon{
        margin: 0 30px;
    }
    .headerRow{
        /* display: flex;
        justify-content: space-around; */
        padding: 22px 68px 22px 15px;
        background: #F7F7F7;
        border-radius: 4px;
        height: 60px;
    }

    .rowItem{
        /* display: flex;
        justify-content: space-around; */
        padding: 12px 20px 12px 20px;
    }

    .item{
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 500;
        font-size: 11.269px;
        line-height: 22px;
        color: #41434C;
        opacity: 0.8;
        text-align: center;
    }

    .rows{
        margin: 0 24px 20px;
        background: #FFFFFF;
        padding: 12px;
        border-radius: 4px;
    }

    .rowtitle{
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 130%;
        color: #141414;
    }

    .advancedReportsContainer{
        width: 100%;
        background: #F8F8F8;
    }

    .titleWrapper{
        display: flex;
        align-items: center;
        max-width: 300px;
    }

    .arrow{
        margin-right: 15px;
        width: 18px;
        height: 14px;
        cursor: pointer;
    }

    .headerWrapper{
        display: flex;
        justify-content: space-between;
        padding: 24px 30px 20px 14px;
        margin-bottom: 22px;
        background: #FFFFFF;

    }

    .title{
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 140%;
        color: #373737;
    }

    .saveBtn{
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        color: #0004B5;
        opacity: 0.8;
        padding: 6px 20px;
        border: 1px solid #2E31BE;
        border-radius: 4px;
        cursor: pointer;
    }
    .hide {
        visibility: hidden;
    }
</style>